import react, {useState, useEffect} from "react";
import { Image as AntdImage, Modal, Form, Input, message, Typography } from "antd";

import Api from "../../../api";
import "./index.scss"

const { Link } = Typography;
const { TextArea } = Input;
const TeamModal = ({open, teamTitle, details, teamCancel}) => {

    const [addForm] = Form.useForm();
    const [teamOpen, setTeamOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [teamForm, setTeamForm] = useState({});

    useEffect(() => { 
        setTeamOpen(open);
        if(details && open){
            addForm.setFieldsValue({
                ...details,
            });
        }
    }, [open]);
    
    const teamSubmitForm = async () => {
        try {
            if(confirmLoading){
                return false;
            }
            setConfirmLoading(true);
            const row = await addForm.validateFields();
            let res = null;
            if(details.id){
                res = await Api.Team.updateTeam({data:row});
            }else{
                res = await Api.Team.addTeam({data:row});
            }
            setConfirmLoading(false);
            if(res.code === 0){
                handleCancel('success');
                message.success(details.id ? "修改团队成功" : "新增团队成功")
            }
        } catch (errInfo) {
            setConfirmLoading(false);
            console.log('验证失败:', errInfo);
        }

    }

    function handleCancel (type) {
        setConfirmLoading(false);
        setTeamOpen(false);
        teamCancel(type);
    }

    return (
        <Modal 
            title={teamTitle}
            open={teamOpen} 
            onOk={teamSubmitForm} 
            onCancel={handleCancel}
            maskClosable={false}
            destroyOnClose={true}
            confirmLoading={confirmLoading}
        >
            <Form
                form={addForm}
                component={false}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
                preserve={false}
            >
                <Form.Item
                    key={"teamName"}
                    label={"团队名称"}
                    name={"teamName"}
                    rules={[{ required: true, message: `请输入团队名称!` }]}
                >
                    <Input placeholder="请输入团队名称"/>
                </Form.Item>
                <Form.Item
                    key={"teamDesc"}
                    label={"团队简介"}
                    name={"teamDesc"}
                    rules={[{ required: true, message: `请输入团队简介!` }]}
                >
                    <TextArea
                        placeholder="简单说明下这个团队适用于什么场景，以便自己快速区分"
                        style={{
                            height: 120,
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default TeamModal;